import { BillingTab } from "features/settings/common/types";
import { BotType, LanguageNameSpaces, UsageType } from "@shared/types";
import {
  BacktestingQuotaIcon,
  BotsIcon,
  CellTowerIcon,
  DarkDcaBotIcon,
  DarkGridBotIcon,
  DarkHedgingBotIcon,
  DarkSignalsBotIcon,
  DarkTradingViewBotIcon,
  DcaBotIcon,
  HedgingBotIcon,
  GridBotIcon,
  GridBotsIcon,
  SignalBotsIcon,
  SignalsBotIcon,
  SimpleHedgingBotIcon,
  SimpleGridBotsIcon,
  SimpleTradingViewBotsIcon,
  TradingViewBotIcon,
  TvBotsIcon,
} from "common/Icons/Icons";
import SettingOutlined from "@ant-design/icons/SettingOutlined";
import SwapOutlined from "@ant-design/icons/SwapOutlined";
import { IS_WEB_VIEW } from "common/constants.ts";
import { isAndroid, isIOS } from "react-device-detect";
import { TranslationKeys } from "@shared/common/i18n/types.ts";

export const TAB_TO_DISPLAY: Record<
  BillingTab,
  TranslationKeys<LanguageNameSpaces.BILLING>
> = {
  [BillingTab.CORNIX]: "tabs.cornix",
  [BillingTab.GROUPS]: "tabs.groups",
};

export const MAX_SETTINGS_WIDTH = 1130;
export const MAX_SECURITY_SETTINGS_WIDTH = 700;
export const PLAN_USAGE_CHART_HEIGHT = 245;
export const DRAWER_CHECKOUT_WIDTH = 850;

export const USAGE_TYPE_TO_ICON = {
  [UsageType.ACTIVE_TRADE]: CellTowerIcon,
  [UsageType.MANUAL_TRADE]: SwapOutlined,
  [UsageType.CLIENT]: SettingOutlined,
  [UsageType.DCA_BOT]: BotsIcon,
  [UsageType.GRID_BOT]: GridBotsIcon,
  [UsageType.TV_BOT]: TvBotsIcon,
  [UsageType.SIGNAL_BOT]: SignalBotsIcon,
  [UsageType.BACKTESTING]: BacktestingQuotaIcon,
  [UsageType.HEDGING_BOT]: SimpleHedgingBotIcon,
};

export const BOT_TYPE_TO_ICON = {
  [BotType.ASAP]: BotsIcon,
  [BotType.TRADING_VIEW]: SimpleTradingViewBotsIcon,
  [BotType.GRID]: SimpleGridBotsIcon,
  [BotType.SIGNAL]: SignalBotsIcon,
  [BotType.HEDGING]: SimpleHedgingBotIcon,
};

export const BOTTOM_NAVIGATOR_BOT_TYPE_TO_ICON = {
  [BotType.ASAP]: DcaBotIcon,
  [BotType.TRADING_VIEW]: TradingViewBotIcon,
  [BotType.GRID]: GridBotIcon,
  [BotType.SIGNAL]: SignalsBotIcon,
  [BotType.HEDGING]: HedgingBotIcon,
};
export const DARK_BOTTOM_NAVIGATOR_BOT_TYPE_TO_ICON = {
  [BotType.ASAP]: DarkDcaBotIcon,
  [BotType.TRADING_VIEW]: DarkTradingViewBotIcon,
  [BotType.GRID]: DarkGridBotIcon,
  [BotType.SIGNAL]: DarkSignalsBotIcon,
  [BotType.HEDGING]: DarkHedgingBotIcon,
};
export const PROMO_CODE_QUERY_PARAM = "promo_code";
export const EMAIL_QUERY_PARAM = "email";
export const BILLING_HISTORY_QUERY_PARAM = "billing-history";
export const LOCAL_STORAGE_PAYMENTS_KEY = "pending-payments";

export const SMALL_MOBILE_CHECKOUT_HEIGHT = "700px";

export const IS_APPLE_PAY = IS_WEB_VIEW && isIOS;
export const IS_GOOGLE_PAY = IS_WEB_VIEW && isAndroid;
